// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';

export const deleteTagPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
  id: z.number().int().describe("Label ID"),
});

export const deleteTagHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Label deleted successfully
 */
export const deleteTag200Schema = z.object({});

/**
 * @description Label not found
 */
export const deleteTag404Schema = z.lazy(() => v1NotFoundErrorSchema);

export const deleteTagMutationResponseSchema = z.lazy(() => deleteTag200Schema);
